
				var addMethods = require("../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["wasm"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "cef539fb.worker.js", { name: "[contenthash:8].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "cef539fb.worker.js");
					addMethods(w, methods)
					
					return w
				}
			